import { compileProvider } from './compileProvider';
import { locationProvider } from './locationProvider';
import { ngReduxProvider } from './ngReduxProvider';
//import { redirectMiddleware } from './redirect-middleware';
import { stateProvider } from './stateProvider';

export const Providers = angular
  .module('App.providers', [])
  .config(compileProvider)
  .config(locationProvider)
  .config(stateProvider)
  .config(ngReduxProvider).name;
//.factory('redirectMiddleware', redirectMiddleware).name;



// WEBPACK FOOTER //
// ./src/providers/index.js